<template>
  <div class="mt-3">
    <ClubIcon 
    :name="name"
    :shield="shield"
    :ball="ball"
    ></ClubIcon>
    <div class="competition-team-name">
      {{name}}
    </div>
  </div>
</template>

<script>
  import ClubIcon from './ClubIcon';

  export default {
    name: 'CompetitionTeam',
    components: {
      ClubIcon
    },
    props: ['name','shield','ball']
  }
</script>
